module.exports = __webpack_public_path__ + "img/PayamIbrahim-QabiXwardnawa.5a6ba61d.jpg";